import Vue from "vue";

export const log = {
  methods: {
    //新增安全员日志
    async addSecuritylog(obj) {
      let res = await this.$http.post("/tenant/person/log", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //修改安全员日志
    async upSecuritylog(obj) {
      let res = await this.$http.put("/tenant/person/log", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
    },
    
    //删除安全员日志
    async delSecuritylog(obj) {
      let res = await this.$http.delete(`/tenant/person/log/${obj.id}`);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
    },
   //获取安全日志详细信息
   async getSecuritylogInfo(id) {
    let res = await this.$http.get(`/tenant/person/log/${id}`);
    console.log(res);
    return res.data;
  },
    //获取所有安全员日志
    async getSecuritylogList(req) {
      let { pageNum, pageSize, logTime ,type } = req;

      let res = await this.$http.get("/tenant/person/log/list", {
        type:type,
        logTime: logTime ?? null,
        pageNum,
        pageSize,
      });
      return res;
    },

    //TODO： 申请修改安全员日志
    async applySecuritylog(obj) {
        let res = await this.$http.post(`/tenant/person/log/apply/update/${obj.id}`);

        if (res.code == 200) {
            this.$message({ message: res.msg, type: "success" });
          } else {
            this.$message.error(res.msg);
          }
    },
    //TODO：获取安全部长审核列表
    async getSecuritylogApplyList(req) {
        let { pageNum, pageSize, createTime } = req;

        let res = await this.$http.get("/tenant/log/approve/list", {
          createTime: createTime ?? null,
          pageNum,
          pageSize,
        });
        return res;
    },
    //TODO: 安全部长审核（同意）
    async agreeSecuritylog(obj) {
        let res = await this.$http.put(`/tenant/log/approve`,{
            personLogId:obj.personLogId,
            type:obj.type,
            id: obj.id,
            status:1
        });

        if (res.code == 200) {
            this.$message({ message: res.msg, type: "success" });
          } else {
            this.$message.error(res.msg);
          }
    },
    //TODO: 安全部长审核（不同意）
    async disagreeSecuritylog(obj) {
        let res = await this.$http.put(`/tenant/log/approve`,{
            personLogId:obj.personLogId,
            type:obj.type,
            id: obj.id,
            status:2
        });

        if (res.code == 200) {
            this.$message({ message: res.msg, type: "success" });
          } else {
            this.$message.error(res.msg);
          }
    },
    //TODO：查找修改日志对比详细信息
    async getSecuritylogDetail(obj) {
        let res = await this.$http.get(`/tenant/log/approve/${obj.id}`);
        return res.data;
    }
  },
};
